import { api } from '@goaltree/backend/convex/_generated/api'
import { useQuery } from 'convex/react'
import { useTranslation } from 'react-i18next'

// Consistency (habit hit rate, 30 days) and this year's completions — personal
// stats that used to be leaderboard boards.
export function ConsistencyStats() {
  const { t } = useTranslation()
  const me = useQuery(api.leaderboard.getMyLeaderboardRank)
  const meta = useQuery(api.leaderboard.getLeaderboardMeta)
  if (!me || !meta) return null
  const rate = me.entry.successRate
  const year = me.entry.yearCount ?? 0
  const tiles = [
    rate !== undefined && {
      key: 'rate',
      value: `${rate}%`,
      label: t('leaderboard.rateTab'),
      sub: t('leaderboard.rateSub'),
      rank: me.rateRank,
    },
    {
      key: 'year',
      value: String(year),
      label: t('leaderboard.yearTab'),
      sub: t('leaderboard.yearSub', { year: meta.yearKey }),
      rank: year > 0 ? me.yearRank : null,
    },
  ].filter(Boolean) as {
    key: string
    value: string
    label: string
    sub: string
    rank?: number | null
  }[]

  return (
    <section className="grid grid-cols-2 gap-3">
      {tiles.map((tile) => (
        <div
          key={tile.key}
          className="flex flex-col gap-0.5 rounded-2xl border border-border/60 bg-card/40 p-4"
        >
          <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-foreground/40">
            {tile.label}
          </span>
          <span className="text-2xl font-black tabular-nums text-foreground">{tile.value}</span>
          <span className="text-[11px] leading-snug text-muted-foreground">{tile.sub}</span>
          {tile.rank != null && (
            <span className="mt-1 font-mono text-[11px] text-primary-text">
              {t('stats.rankOnBoard', { rank: tile.rank })}
            </span>
          )}
        </div>
      ))}
    </section>
  )
}
